import PropTypes from 'prop-types';
import { formattedPriceString } from '../utils/formattedPriceString';
import { useTranslation } from '../i18n';

export function FormattedPrice({ value }) {
  const { t } = useTranslation();

  return formattedPriceString(value, t('price'));
}

FormattedPrice.propTypes = {
  value: PropTypes.number.isRequired
};
